import { render, staticRenderFns } from "./BaseStrengthBar.vue?vue&type=template&id=68237e05&scoped=true&"
import script from "./BaseStrengthBar.vue?vue&type=script&lang=js&"
export * from "./BaseStrengthBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseStrengthBar.vue?vue&type=style&index=0&id=68237e05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68237e05",
  null
  
)

export default component.exports